import { Tooltip, Box } from '@chakra-ui/react';
import { ReactNode, useState } from 'react';

export const TooltipWithTouch = ({
  children,
  isDisabled,
  ...restToolTipProps
}: {
  children: ReactNode;
  isDisabled: boolean | undefined;
  [key: string]: any;
}) => {
  const [isLabelOpen, setIsLabelOpen] = useState(false);

  return (
    <Tooltip isOpen={isLabelOpen} {...restToolTipProps}>
      {isDisabled ? (
        children
      ) : (
        <Box
          onMouseEnter={() => setIsLabelOpen(true)}
          onMouseLeave={() => setIsLabelOpen(false)}
          onClick={() => setIsLabelOpen(true)}
        >
          {children}
        </Box>
      )}
    </Tooltip>
  );
};
